import store from '../store'

export default function checkFeature(to, next) {
  if (to.matched.some(record => record.meta.is_pro)) {
    if (store.getters['user/isPro']) {
      next()
    } else {
      next({ path: '/' })
    }

    return
  }

  const featureRoute = to.matched.find(record => record.meta.premiumFeatures)
  if (featureRoute) {
    const user = store.getters['user/user'] || {}
    const userFeatures = user.premium_features || []
    const allowed = featureRoute.meta.premiumFeatures.some(f => userFeatures.includes(f))
    if (allowed) {
      next()
    } else {
      next({ path: '/' })
    }

    return
  }

  next()
}
